const mixinValidations = {
  methods: {
    async validationInput(reference, indexnum) {
      let elementsArray = document.getElementsByClassName(
        'required-' + reference
      );

      for (let i = 0; i < elementsArray.length; i++) {
        if (i == indexnum) {
          let inputsArray = elementsArray[i].getElementsByTagName('input');
          for (let index of inputsArray) {
            index.focus();
            index.classList.add('custom-has-error');
            this.removeHasError(index);
            return false;
          }
        }
      }

      return true;
    },

    async validationInputsRequired(
      reference,
      zeroRequired = false,
      allElements = false
    ) {
      const elementsArray = document.getElementsByClassName(
        `required-${reference}`
      );

      for (const key of elementsArray) {
        const inputsArray = key.getElementsByTagName('input');
        for (const index of inputsArray) {
          if (zeroRequired || index.value.trim().length === 0) {
            index.focus();
            index.classList.add('custom-has-error');
            this.removeHasError(index);

            if (!allElements) return false;
          }
        }
      }

      return true;
    },

    async validationInputsZeroRequired(reference) {
      let elementsArray = document.getElementsByClassName(
        'required-' + reference
      );

      for (let key of elementsArray) {
        let inputsArray = key.getElementsByTagName('input');
        for (let index of inputsArray) {
          index.focus();
          index.classList.add('custom-has-error');
          this.removeHasError(index);
          return false;
        }
      }

      return true;
    },

    async removeHasError(index) {
      if (index.classList.contains('el-input__inner')) {
        setTimeout(() => {
          index.classList.remove('custom-has-error');
        }, 3000);
      }

      return true;
    },

    async validateVariousSelect(amount, modelData, required) {
      const passed = [];

      for (let i = 0; i < amount; i++) {
        for (const [index, model] of modelData.entries()) {
          if (!model[i] || model[i] === '' || model[i] === null) {
            passed.push(false);
            await this.validationInput(required[index], i);
          } else {
            passed.push(true);
          }
        }
      }

      return passed;
    },
  },
};

export default mixinValidations;
